import api from "api"
import { AllIntegrationTypes, integrationTypesByKeys } from "models/integrations"

export const toggleIntegration = (integrationType: AllIntegrationTypes, value: boolean) => {
    const key = integrationTypesByKeys[integrationType]
    return api.post(`/administration/integrations/${key}/toggle`, {value})
  }


export default toggleIntegration